module.exports = __webpack_public_path__ + "img/forbid.3f900c45.png";